/**
 * @generated SignedSource<<36bc959842a3b233df2bee291b1fd729>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type StreamMeetingRecapSendTo = "ALL" | "INTERNAL" | "INTERNAL_ON_FELLOW" | "NONE";
export type UserMeetingRecapSendTo = "ALL" | "INTERNAL" | "JUST_ME" | "NONE";
import { FragmentRefs } from "relay-runtime";
export type AutoSendToEveryone_autoShareIsSetToEveryone_note$data = {
  readonly stream: {
    readonly meetingRecapAutoShareSource: {
      readonly __typename: "StreamMeetingRecapAutoShareSettings";
      readonly sendTo_S: StreamMeetingRecapSendTo;
    } | {
      readonly __typename: "UserMeetingRecapAutoShareSettings";
      readonly sendTo_U: UserMeetingRecapSendTo;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null;
  };
  readonly " $fragmentType": "AutoSendToEveryone_autoShareIsSetToEveryone_note";
};
export type AutoSendToEveryone_autoShareIsSetToEveryone_note$key = {
  readonly " $data"?: AutoSendToEveryone_autoShareIsSetToEveryone_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"AutoSendToEveryone_autoShareIsSetToEveryone_note">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "AutoSendToEveryone_autoShareIsSetToEveryone_note"
};

(node as any).hash = "823b297e08f7ebc96fa8e0ce5994efde";

export default node;
